import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import CTA from './components/CTA';
import Footer from './components/Footer';
import LearnMore from './components/LearnMore';
import WhatIsHumanAI from './components/WhatIsHumanAI';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookiePolicy from './components/CookiePolicy';
import CookieConsent from './components/CookieConsent';
import BlogTitle from './components/BlogTitle';
import RevolutionizingSurveyResearch from './blogposts/RevolutionizingSurveyResearch';
import DayOneBenchmark from './blogposts/DayOneBenchmark';
import AIRespondentsValueProp from './blogposts/AIRespondentsValueProp';
import BlogStanfordGenerativeAgents from './blogposts/BlogStanfordGenerativeAgents';
import AITwinProject from './blogposts/AITwinProject';
import CanAIPredictPublicOpinion from './blogposts/CanAIPredictPublicOpinion';
import AnthologyVirtualPersonas from './blogposts/AnthologyVirtualPersonas';
import ConversationalSurveyBuilder from './blogposts/ConversationalSurveyBuilder';
import TrustHumansAndAI from './blogposts/TrustHumansAndAI';
import BadSurveyQuestions from './blogposts/BadSurveyQuestions';
import PollstersDilemma from './blogposts/PollstersDilemma';
import TimeOfDay from './blogposts/TimeOfDay';
import WeightingSiliconSample from './blogposts/WeightingSiliconSample';
import ComprehensiveGuideToSR from './blogposts/ComprehensiveGuideToSR';
import ReviewOfSRResearch from './blogposts/ReviewOfSRResearch';
import OverviewSR from './blogposts/OverviewSR';
import SRAsPilots from './blogposts/SRAsPilots';
import LLMsVABM from './blogposts/LLMsVABM';
import Pricing from './components/Pricing';

// Wrapper component for cookie consent functionality
function CookieConsentWrapper() {
  return <CookieConsent />;
}

// Home page component
function HomePage() {
  return (
    <>
      <Hero />
      <Features />
      <CTA />
    </>
  );
}

function AppContent() {
  const navigate = useNavigate();
  
  const navigateTo = (path) => {
    navigate(`/${path}`);
  };

  return (
    <div className="bg-black min-h-screen text-white">
      <CookieConsentWrapper />
      <Navbar />
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/learn-more" element={<LearnMore />} />
        <Route path="/what-is-human-ai" element={<WhatIsHumanAI />} />
        <Route path="/blog" element={<BlogTitle />} />
        <Route path="/blog/day-one-benchmark" element={<DayOneBenchmark />} />
        <Route path="/blog/revolutionizing-survey-research" element={<RevolutionizingSurveyResearch />} />
        <Route path="/blog/ai-respondeny-value-prop" element={<AIRespondentsValueProp />} />
        <Route path="/blog/stanford-generative-agents" element={<BlogStanfordGenerativeAgents />} />
        <Route path="/blog/ai-twin-project" element={<AITwinProject />} />
        <Route path="/blog/can-ai-predict-public-opinion" element={<CanAIPredictPublicOpinion />} />
        <Route path="/blog/anthology-virtual-personas" element={<AnthologyVirtualPersonas />} />
        <Route path="/blog/conversational-survey-builder" element={<ConversationalSurveyBuilder />} />
        <Route path="/blog/trust-humans-and-ai" element={<TrustHumansAndAI />} />
        <Route path="/blog/bad-survey-questions" element={<BadSurveyQuestions />} />
        <Route path="/blog/pollsters-dilemma" element={<PollstersDilemma />} />
        <Route path="/blog/time-of-day" element={<TimeOfDay />} />
        <Route path="/blog/weighting-silicon-sample" element={<WeightingSiliconSample />} />
        <Route path="/blog/comprehensive-guide-to-sr" element={<ComprehensiveGuideToSR />} />
        <Route path="/blog/review-of-sr-research" element={<ReviewOfSRResearch />} />
        <Route path="/blog/overview-sr" element={<OverviewSR />} />
        <Route path="/blog/sr-as-pilots" element={<SRAsPilots />} />
        <Route path="/blog/llms-vs-abm" element={<LLMsVABM />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/pricing" element={<Pricing />} />
      </Routes>
      
      <Footer navigateTo={navigateTo} />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
